@if (_events.length > 0) {
  <div @expandHeight class="padding container">
    <div [routerLink]="['system', 'systemEvents', _eventID]" [attr.role]="_isNotice ? 'status' : 'alert'"
      class="banner flex-item" [class.notice]="_isNotice" [class.error]="!_isNotice">
      <h3>
        @if (_isNotice) {
          <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.notice' | transloco">info</mat-icon>
        } @else {
          <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.warning' | transloco">warning</mat-icon>
        }
        {{ _eventMessage }}
      </h3>
    </div>
    <div class="dismiss-split">
      <button mat-stroked-button class="dismiss-main" (click)="dismissForNow()">{{ 'common.labels.dismiss' | transloco }}</button>
      <button mat-stroked-button class="dismiss-toggle" [matMenuTriggerFor]="dismissMenu"
        [attr.aria-label]="'common.labels.moreDismissOptions' | transloco">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </div>
    <mat-menu #dismissMenu="matMenu">
      <button mat-menu-item (click)="dismissForNow()">{{ 'common.labels.forNow' | transloco }}</button>
      <button mat-menu-item (click)="dismissForOneDay()">{{ 'common.labels.forADay' | transloco }}</button>
    </mat-menu>
  </div>
}